export class ImageStyleUriViewModel {
  background?: string;

  cardImage?: string;

  fullwidthContainer?: string;

  gallery?: string;

  icon?: string;

  teaser2cols?: string;

  // Añade aquí el resto de estilos que necesites según tu modelo de dominio

  constructor(data: Partial<ImageStyleUriViewModel>) {
    this.background = data.background;
    this.cardImage = data.cardImage;
    this.fullwidthContainer = data.fullwidthContainer;
    this.gallery = data.gallery;
    this.icon = data.icon;
    this.teaser2cols = data.teaser2cols;
    // Inicializa el resto de estilos según tu modelo de dominio
  }
}
